export default class FormsUtils {
    public static optionalSelect = (value: string): string | null => {
        return value === "select" ? null : value
    };
}
